
import { SVGProps } from 'react';
const SvgChevronRight12 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 12 12"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1}
			d="m5 9 3-3-3-3"
		/>
	</svg>
);
export default SvgChevronRight12;
